import React, {useEffect, useState} from 'react';
import {Button, ButtonGroup, Card, CardBody, CardHeader, CardTitle, Col, Row} from "reactstrap";
import classNames from "classnames";
import BarChart from "../../../../components/Chart/BarChart";
import {BarChartTransformer, pieChartTransformer} from "../../../services/chart.transformer";
import PieChart from "../../../../components/Chart/PieChart";

const ReportPieChart = (props) => {
    const {data,years} = props
    const [bigChartData, setBigChartData] = useState(null)
    const [chartData, setChartData] = useState(null)

    const ChartData = (year) =>{
        setBigChartData(year)
       const datas = data.filter(y => y.year === year)
        setChartData(datas[0])
    }
    useEffect(()=>{
        ChartData(years[0])
    },[])

    return(
        <Col xs="12">
            <Card className="card-chart">
                <CardHeader>
                    <Row>
                        <Col className="text-right" sm="6">
                            <h5 className="card-category">نمودار دایره ای</h5>
                        </Col>
                        <Col sm="6">

                            <ButtonGroup
                                className="btn-group-toggle float-left"
                                data-toggle="buttons"
                            >
                                {
                                    years && years.map(data => (
                                        <Button
                                            tag="label"
                                            className={classNames("btn-simple", {
                                                active: bigChartData === data,
                                            })}
                                            color="info"
                                            id={data}
                                            size="sm"
                                            onClick={() => ChartData(data)}
                                        >
                                            <span
                                                className="d-none d-sm-block d-md-block d-lg-block d-xl-block">{data}</span>
                                            <span className="d-block d-sm-none"><i
                                                className="tim-icons icon-single-02"/></span>
                                        </Button>
                                    ))
                                }

                            </ButtonGroup>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    <Row>
                    <div className=" chart-area">
                        {chartData &&
                        <PieChart
                            data={pieChartTransformer(chartData?.values)}
                        />}
                    </div>

                    </Row>
                </CardBody>
            </Card>
        </Col>
    )
};

export default ReportPieChart;